'use strict';

var NewExtractNoCalendarSubpanelDirective = function NewExtractNoCalendarSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-no-calendar-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractNoCalendarSubpanelDirective.$inject = [];
module.exports = NewExtractNoCalendarSubpanelDirective;